<template>
	<my-dialog :visible.sync="editFormVisible" :title="title" :close-on-click-modal="false" width="35%" dialog-type="form" :close-immediate="true" @close="closeDialog">
		<el-form ref="ruleForm" label-width="9rem" :model="formInline" class="demo-form-inline" inline style="max-height: 22rem; overflow-y: auto" size="small">
			<el-form-item v-for="(formobj, index) in initForm.formList" :key="index" style="min-width: 45%" :label="formobj.label">
				<!-- inupt输入框 -->
				<el-input clearable v-if="formobj.input" v-model="formInline[formobj.prop]" class="input_200px" :placeholder="`请输入${formobj.label}`" />
				<!-- select选择器 -->
				<el-select v-if="formobj.select" v-model="formInline[formobj.prop]" class="input_200px" :placeholder="`请选择${formobj.label}`" clearable filterable :multiple="formobj.multiple">
					<el-option v-for="(optionItem, sIndex) in formobj.options" :key="sIndex" :label="optionItem[formobj.modelLabel]" :value="optionItem[formobj.modelValue]" />
				</el-select>
				<el-select v-if="formobj.selectNum" v-model="formInline[formobj.prop]" class="input_200px" :placeholder="`请选择${formobj.label}`" clearable filterable :multiple="formobj.multiple">
					<el-option v-for="(optionItem, sIndex) in formobj.options" :key="sIndex" :label="optionItem[formobj.modelLabel]" :value="Number(optionItem[formobj.modelValue])" />
				</el-select>
				<!-- 年月日选择器 -->
				<el-date-picker v-if="formobj.datePicker" v-model="formInline[formobj.prop]" class="input_200px" value-format="yyyy-MM-dd" :placeholder="`请选择${formobj.label}`" />
				<!-- 年月日选择器，开始和结束年月日 -->
				<el-date-picker
					v-if="formobj.datePickerIsRange"
					v-model="formInline[formobj.prop]"
					class="input_200px"
					:value-format="formobj.valueFormat || 'yyyy-MM-dd'"
					:type="formobj.pickerType || 'daterange'"
					:placeholder="`请选择${formobj.label}`"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="!formobj.showPickerOptions || pickerOptions"
					@change="changeDateRange($event, formobj.startProp, formobj.endProp)"
				/>
				<el-switch v-if="formobj.switch" v-model="formInline[formobj.prop]" :active-text="formobj.activeText" :inactive-text="formobj.inactiveText"></el-switch>
				<el-tooltip v-if="formobj.tooltipSwitch" :content="`${formobj.label}：${formInline[formobj.prop] === formobj.options[0].value ? formobj.options[0].name : formobj.options[1].name}`">
					<el-switch v-model="formInline[formobj.prop]" :active-value="formobj.options[1].value" :inactive-value="formobj.options[0].value"></el-switch>
				</el-tooltip>
				<el-cascader
					v-if="formobj.cascader"
					v-model="formInline[formobj.prop]"
					:options="formobj.options"
					class="input_200px"
					:props="formobj.cascaderProps"
					:clearable="true"
					:placeholder="`请选择${formobj.label}`"
					@change="handleCascaderChange($event, formobj.prop)"
				></el-cascader>
			</el-form-item>
		</el-form>
		<template #footer>
			<div class="dialog-footer">
				<el-button v-if="showClear" size="small" @click="clearAll">重置</el-button>
				<el-button size="small" type="primary" class="title" @click="submitForm('editForm')">
					{{ btnName }}
				</el-button>
			</div>
		</template>
	</my-dialog>
</template>

<script>
export default {
	name: "FilterMore",
	props: {
		title: {
			type: String,
			default: "高级筛选"
		},
		showClear: {
			type: Boolean,
			default: true
		},
		btnName: {
			type: String,
			default: "筛选"
		}
	},
	data() {
		return {
			editFormVisible: false,
			formInline: {},
			initForm: {
				initSearch: {},
				formList: [
					/*  {
                         label: '入库类型：',                    // 默认显示的label
                         prop: 'type',                          // 对应的数据对象属性名
                         input: true,                           // 类型 暂时只有input select datePicker datePickerIsRange
                         select: true,
                         datePicker: true,
                         switch:true,
                         cascader:true,
                         datePickerIsRange: true,
                         multiple:true,                         // select是否多选
                         modelValue: 'value',                   // select 绑定的数据对象属性名
                         modelLabel: 'name',
                         options: this.inboundOrderTypeList     // select的options数据
                         startProp: 'createStartTime',          // datePickerIsRange 对应的数据对象属性名
                         endProp: 'createEndTime',
                         valueFormat: 'yyyy-MM-dd',
                         pickerType:'datetimerange',
                         activeText: '同时审批',                // switch的文字
                         inactiveText: '同时审批',                // switch的文字
                         cascaderProps:{                        // cascader的配置参数
                              expandTrigger: 'hover',
                            label: 'dicText',
                            value: 'dicCode',
                            children: 'subData',
                            checkStrictly: true,
                         }
                     } */
				]
			},
			pickerOptions: {
				shortcuts: [
					{
						text: "最近一周",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						}
					},
					{
						text: "最近一个月",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						}
					},
					{
						text: "最近三个月",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						}
					}
				]
			}
		};
	},
	mounted() {},
	methods: {
		filterShow(param, initForm) {
			this.formInline = JSON.parse(JSON.stringify(param));
			this.initForm = initForm;
			// 判断 是否已存在开始结束时间
			initForm.formList.map((item) => {
				if (item.datePickerIsRange && item.startProp && item.endProp) {
					if (param[item.startProp] && param[item.endProp]) {
						this.formInline[item.prop] = [param[item.startProp], param[item.endProp]];
						this.formInline = { ...this.formInline };
					}
				}
			});
			this.editFormVisible = true;
		},
		handleCascaderChange(value, prop) {
			this.formInline[prop] = value[value.length - 1];
		},
		submitForm() {
			this.editFormVisible = false;
			this.$emit("filterMoreCallBack", this.formInline);
		},
		closeDialog() {
			this.editFormVisible = false;
		},
		// 重置
		clearAll() {
			this.formInline = JSON.parse(JSON.stringify(this.initForm.initSearch));
		},
		// 起止时间
		changeDateRange(val, startProp, endProp) {
			if (startProp && endProp) {
				if (val && val !== "") {
					this.formInline[startProp] = val[0];
					this.formInline[endProp] = val[1];
				} else {
					this.formInline[startProp] = null;
					this.formInline[endProp] = null;
				}
			}
			this.formInline = { ...this.formInline };
		}
	}
};
</script>

<style scoped></style>
